<template>
  <div class="common-box border-t0">
    <el-row class="row-one">
      <span class="row-one-title">恒宝宝交易详情</span>
      <Reback class="row-one-fr" @click.native="returnClick"></Reback>
    </el-row>
    <!-- 详情 -->
    <div>
      <!-- 确认中时间线 -->
      <section class="xDetail" v-if="messageDetail.transstatus == '03' &&confirmTime.transactiondate != '19900101' && messageDetail.businesscode != '43'">
        <ul class="xDetail-stepstwo margin-t10" v-if="messageDetail.businesscode == '24'|| messageDetail.businesscode == '122'">
          <li class="xDetail-stepstwo-li" style="width:50%">
            <span class="xDetail-stepstwo-li-spanone">申请已提交，等待处理</span>
            <span>{{this.$commonJs.getDateStrHg(messageDetail.operdate).slice(5) +'(今天)'}} </span>
            <div class="xDetail-stepstwo-li-img">
              <img src="../../../assets/images/20210316_dg.png" alt="">
              <div class="xDetail-stepstwo-li-img-line" style="left: 172px;width: 94%;"></div>
            </div>
          </li>
          <li class="xDetail-stepstwo-li" style="width:50%">
            <span class="xDetail-stepstwo-li-spanone">预计到账时间</span>
            <span>{{confirmTime.firstpftdate +'('+confirmTime.firstpftworkday +')'}}</span>
            <div class="xDetail-stepstwo-li-img">
              <img src="../../../assets/images/20210316_sy.png" alt="">
            </div>
          </li>
        </ul>
        <ul class="xDetail-stepstwo margin-t10" v-else>
          <li class="xDetail-stepstwo-li">
            <span class="xDetail-stepstwo-li-spanone">转入提交</span>
            <span>{{this.$commonJs.getDateStrHg(confirmTime.transactiondate).slice(5)+'(今天)'}}</span>
            <div class="xDetail-stepstwo-li-img">
              <img src="../../../assets/images/20210316_dg.png" alt="">
              <div class="xDetail-stepstwo-li-img-line"></div>
            </div>
          </li>
          <li class="xDetail-stepstwo-li">
            <span class="xDetail-stepstwo-li-spanone">开始计算收益</span>
            <span>{{confirmTime.expectcfmdate +'('+confirmTime.expectcfmworkday +')'}}</span>
            <div class="xDetail-stepstwo-li-img">
              <img src="../../../assets/images/time.png" alt="">
              <div class="xDetail-stepstwo-li-img-line"></div>
            </div>
          </li>
          <li class="xDetail-stepstwo-li">
            <span class="xDetail-stepstwo-li-spanone">首笔收益到账</span>
            <span>{{confirmTime.firstpftdate +'('+confirmTime.firstpftworkday +')'}}</span>
            <div class="xDetail-stepstwo-li-img">
              <img src="../../../assets/images/20210316_sy.png" alt="">
            </div>
          </li>
        </ul>
      </section>
      <!-- 充值 -->
      <div class="casebox-one_success clearfix">
        <!-- 上 -->
        <div class="trade-records" v-show="messageDetail.businesscode != '43'">
          <div class="trade-records-fl">
            <!-- 图片1 -->
            <img src="../../../assets/images/hbb/bigRight.png" alt="" width="40" v-show="messageDetail.transstatus != '02'&&messageDetail.transstatus != '04'&&messageDetail.transstatus != '06'">
            <img src="../../../assets/images/hbb/error.png" width="40" alt="" v-show="messageDetail.transstatus == '02'||messageDetail.transstatus == '04'||messageDetail.transstatus == '06'">
            <p class="aColor margin-t10">{{detailName}}</p>
            <p>{{this.acceptanceTime}}</p>
          </div>
          <div class="trade-records-shu"></div>
          <ul class="trade-records-ul1">
            <li><span>交易编号：</span><span>{{messageDetail.appsheetserialno != ' '? messageDetail.appsheetserialno:'--'}}</span></li>
            <li v-show="messageDetail.transstatus != '00' && messageDetail.businesscode != '122' && messageDetail.businesscode != '124'"><span>产品名称：</span><span>恒宝宝</span></li>
            <li v-show="messageDetail.transstatus == '00' || messageDetail.businesscode == '122' || messageDetail.businesscode == '124'"><span>相关基金：</span><span>{{messageDetail.relatfundcode==''?'['+messageDetail.fundcode+']'+messageDetail.fundname:'['+messageDetail.relatfundcode+']'+messageDetail.relatfundname}}</span></li>
            <li><span>交易类型：</span><span>{{messageDetail.tradeType}}</span></li>
            <li><span>申请时间：</span><span>{{messageDetail.applyTime.substr(0,11)}}</span></li>
            <li v-show="messageDetail.businesscode != '24' && messageDetail.businesscode != '122'"><span>申请金额：</span><span>{{messageDetail.transamount + '元'}}</span></li>
            <li v-show="messageDetail.businesscode == '24' || messageDetail.businesscode == '122'"><span>申请份额：</span><span>{{messageDetail.transamount + '份'}}</span></li>
            <!-- <li><span>优惠券抵扣金额：</span><span>{{}}</span></li> -->
            <li v-show="messageDetail.transstatus != '06' && messageDetail.transstatus != '00' && messageDetail.businesscode != '122'"><span>支付方式：</span><span>{{payCard}}</span></li>
            <li v-show="messageDetail.transstatus == '06'"><span>失败原因：</span><span>支付失败(未支付)</span></li>
            <li v-show="messageDetail.transstatus == '00'"><span>处理状态：</span><span>{{messageDetail.status}}</span></li>
          </ul>
        </div>
        <!-- 上分红 -->
        <div class="trade-records" v-show="messageDetail.businesscode == '43'">
          <div class="trade-records-fl">
            <!-- 图片1 -->
            <img src="../../../assets/images/hbb/bigRight.png" alt="" width="40" v-show="messageDetail.transstatus != '06'">
            <img src="../../../assets/images/hbb/error.png" width="40" alt="" v-show="messageDetail.transstatus == '06'">
            <p class="aColor margin-t10">{{detailName}}</p>
            <p>{{messageDetail.applyTime}}</p>
          </div>
          <div class="trade-records-shu"></div>
          <ul class="trade-records-ul1">
            <li><span>交易编号：</span><span>{{messageDetail.appsheetserialno != ' '? messageDetail.appsheetserialno:'--'}}</span></li>
            <li><span>产品名称：</span><span>恒宝宝</span></li>
            <li><span>确认时间：</span><span>{{this.$commonJs.getDateStrHz(messageDetail.transactiondate)}}</span></li>
            <li><span>分红方式：</span><span>红利再投资</span></li>
            <!-- 原项目为变量 -->
            <li><span>关联账户：</span><span>银行卡</span></li>
            <li><span>分红金额：</span><span>{{messageDetail.transamount + '元'}}</span></li>
          </ul>
        </div>
        <!-- 下 -->
        <div class="trade-records" v-show="(messageDetail.transstatus == '01' ||messageDetail.transstatus == '03' ||messageDetail.transstatus == '05' ||messageDetail.transstatus == '03') &&  messageDetail.businesscode != '43' && messageDetail.transstatus != '05'">
          <div class=" trade-records-fl">
            <!-- 图片2 -->
            <img v-show="messageDetail.status == '确认中'" src="../../../assets/images/hbb/jsj_20210309.png" alt="" style="width:40px;height:40px;">
            <img v-show="messageDetail.status != '确认中'" src="../../../assets/images/hbb/calculator_right.png" alt="" style="width:40px;height:40px;">
            <p class="aColor margin-t10">{{detailStatus}}</p>
            <p class="aColor">{{detailProgress}}</p>
            <!-- 问题 -->
            <p>{{iodate}}</p>
          </div>
          <!-- 成功 -->
          <div class="trade-records-shu" v-show="messageDetail.status != '确认中'"></div>
          <ul class="trade-records-ul1" v-show="messageDetail.status != '确认中'">
            <li><span>交易状态：</span><span>{{messageDetail.status}}</span></li>
            <li v-show="messageDetail.businesscode != '39' && messageDetail.businesscode != '59' &&messageDetail.businesscode != '60' "><span>交易金额：</span><span>{{messageDetail.transamount + '元'}}</span></li>
            <li v-show="messageDetail.businesscode == '39' || messageDetail.businesscode == '59' ||messageDetail.businesscode == '60' "><span>交易份额：</span><span>{{messageDetail.transamount + '份'}}</span></li>
            <li v-show="messageDetail.businesscode == '124'"><span>相关费用：</span>申购费0.00元<span></span></li>
            <li v-show="messageDetail.businesscode == '122'"><span>相关费用：</span><span>赎回费0.00元</span></li>
            <li v-show="messageDetail.businesscode == '122'"><span>相关账户：</span><span>恒宝宝</span></li>
          </ul>
          <!-- 确认中 -->
          <div class="trade-records-shu1" v-show="messageDetail.status == '确认中'"></div>
          <ul class="trade-records-ul2" v-show="messageDetail.status == '确认中'">
            <li>交易状态：确认中</li>
            <li>{{'交易金额：'+messageDetail.transamount+'元'}}</li>
          </ul>
        </div>
        <!-- confirmTime.status 00待复核  01待勾对  02待报  04废单  05撤单  06已报   07已确认  08已结束 -->
        <div class="xDetail-footer" v-if="confirmTime.cancelflag == 'Y' && (messageDetail.transstatus == '03' || (messageDetail.transstatus == '05' &&  confirmTime.status == '01'))">
          <el-button type="normal" @click="dialogVisable = true">撤单</el-button>
        </div>
        <div class="text-center" v-else>
          <el-button type="back" @click="returnClick">返回</el-button>
        </div>

      </div>
      <!-- 说明 -->
      <div class="margin-t70">
        <!-- 充值说明 -->
        <section class="instruction" v-show="messageDetail.businesscode =='22'  &&　messageDetail.transstatus != '05'">
          <div class="instruction-li">
            <p class="instruction-li-title">交易说明</p>
            <p class="instruction-li-stress">
              <span class="aColor">T日15:00前</span>（充值恒宝宝） —— <span class="aColor">T+1日</span>（开始享受恒宝宝收益）——确认后<span class="aColor">T+2日</span>（查看恒宝宝昨日收益）
            </p>
            <p class="instruction-li-con">
              1. T日为工作日，工作日15:00后的交易将视作下一个工作日的交易发起，相应的确认时间为下一个交易日，成功后开始计算收益。<br>
              2. T日发起交易，T+1日即享受收益，确认成功后即可使用恒宝宝进行取现、购买基金。<br>
              3. 如果充值确认失败，资金将在确认后的2个工作日划向您的银行卡。
            </p>
          </div>
        </section>
        <!-- 充值说明 汇款订单 -->
        <section class="instruction" v-show="messageDetail.businesscode =='22' &&　messageDetail.transstatus == '05'">
          <div class="instruction-li">
            <p class="instruction-li-title">交易说明</p>
            <p class="instruction-li-con">
              汇款支付订单，请于下单当日15：00前将充值金额汇至展恒基金监管账户。如您已完成汇款请忽略该提示。<br>
              付款银行：{{payCard}}<br>
              展恒基金监管账户信息：<br>
              1.银行户名：北京展恒基金销售股份有限公司<br>
              2.银行账号：0101014170028026<br>
              3.开户行：中国民生银行股份有限公司北京木樨地支行<br>
            </p>
          </div>
        </section>
        <!-- 定投说明 -->
        <section class="instruction" v-show="messageDetail.businesscode =='39' || messageDetail.businesscode =='59' || messageDetail.businesscode =='60'">
          <div class="instruction-li">
            <p class="instruction-li-title">交易说明</p>
            <p class="instruction-li-con">
              1. 发起定期定额计划，将在下一工作日生效。如果您设置的定期定额扣款日期为当前工作日，会在申请所属工作日进行第一次扣款。<br>
              2. 终止定期定额计划，将在下一工作日生效。如果终止当前工作日为扣款日期，则仍然会发起一次定期定额交易申请。<br>
              3. 定期定额交易申请因银行卡账户余额不足、网络或通讯故障等导致扣款失败，将在之后的1个工作日内补扣，若仍未成功则取消本期扣款。如补扣顺延到的下一工作日恰好与下一期定投扣款日重叠，则当日只发起一笔扣款。如连续3期（按日定投为6期）扣款失败，系统将自动暂停该定投计划。<br>
              4. 如您不想继续进行定期定额投资，请暂停或是终止定期定额计划，否则系统将继续尝试扣款。<br>
              5. 定期定额计划产生的基金份额，可以全部或是部分赎回、转换。<br>
              6. 我们将 24 小时受理您的交易申请。您交易日的交易申请至 15:00 截止， 15:00 以后的交易申请或非交易日的交易申请视为于下一个交易日提交。您最终申请提交时间以我司注册登记中心接收时间为准。<br>
              7. 由于客户端系统时间与服务器时间可能有误差，请尽量避免在交易截止时间前后进行交易，交易提交时间以本系统服务器时间为准。如因网络原因或网银系统故障，导致划款成功指令未传递到本系统的，我们会在交易日结束后通过银行对账，确认交易成功，15：00前的交易申请将视为当日的申请。
            </p>
          </div>
        </section>
        <!-- 提现说明 -->
        <section class="instruction" v-show="messageDetail.businesscode =='24'">
          <div class="instruction-li">
            <p class="instruction-li-title">交易说明</p>
            <p class="instruction-li-stress">
              <span class="aColor">T日15:00前</span>（申请恒宝宝普通提现） —— <span class="aColor">T+1日</span>（资金汇出）
            </p>
            <p class="instruction-li-con">
              1. T日为工作日，当个工作日15:00后的交易将视作下一个工作日的交易发起，相应的确认时间也顺延。<br>
              2. 普通取现一般款项会在T+1日17:00前划出。个别银行可能存在到账时间延迟，具体到账时间以银行实际到账为准。<br>
              3. 如未到账，详询400-1818-188。
            </p>
          </div>
        </section>
        <!-- 分红说明 -->
        <section class="instruction" v-show="messageDetail.businesscode =='43'">
          <div class="instruction-li">
            <div class="instruction-li-title">交易说明</div>
            <p class="instruction-li-con">
              1. 基金分红一般分为现金分红及红利再投资两种。<br>
              2. 现金分红：一般是现金红利发放日之后的2个工作日款项划向银行卡，建议查询账户内关联银行卡，QDII现金分红到账时间较久，建议您耐心等待。<br>
              3. 红利再投：红利再投份额将于权益登记日之后调增至您的账户。<br>
              4. 如超过正常时间可来电咨询400-888-6661。
            </p>
          </div>
        </section>
        <!-- 基金买入说明 -->
        <section class="instruction" v-show="messageDetail.businesscode =='124'">
          <div class="instruction-li">
            <p class="instruction-li-title">交易说明</p>
            <p class="instruction-li-stress">
              <span class="aColor">T日15:00前</span>（充值恒宝宝） —— <span class="aColor">T+1日</span>（开始享受恒宝宝收益）—— <span class="aColor">T+2日</span>（查看恒宝宝昨日收益）
            </p>
            <p class="instruction-li-con">
              1. T日为工作日，工作日15:00后的交易将视作下一个工作日（T+1）的交易发起，相应的确认时间为下一个交易日（T+2），成功后开始计算买入基金的收益，T+3查看收益。<br>
              2. T日发起交易，T+1日即享收益，T+1日确认成功后即可进行赎回，转换等操作。<br>
              3. 基金交易确认日通常为T+1日（QDII等特殊基金确认日为T+2日），您可以在确认日20:00后查看确认信息。<br>
              4. 如您的交易确认失败，资金将在确认失败后的2个工作日划向您的银行卡。
            </p>
          </div>
        </section>
        <!-- 基金卖出说明 -->
        <section class="instruction" v-show="messageDetail.businesscode =='122'">
          <div class="instruction-li">
            <p class="instruction-li-title">交易说明</p>
            <p class="instruction-li-stress">
              <span class="aColor">T日15:00前</span>（卖出基金申请受理） —— <span class="aColor">T+1日</span>（查看卖出确认情况）—— <span class="aColor">T+2日</span>（确认后1~13个工作日内卖出资金到恒宝宝）
            </p>
            <p class="instruction-li-con">
              1. T日为工作日，当个工作日15:00后的交易将视作下一个工作日的交易发起，相应的确认时间也顺延。<br>
              2. 基金交易确认日通常为T+1日（QDII等特殊基金确认日为T+2日），您可以在确认日20:00后查看确认信息。<br>
              3. 不同类型的基金赎回到账时间不同：一般货币基金T+1~2个工作日；债券基金T+2~4个工作日；混合、股票基金T+3~4个工作日；QDII基金T+4~13个工作日。· 资金到账时间一般为到账工作日17:00前。个别银行可能存在到账时间延迟，具体到账时间以银行实际到账为准。<br>
              4. 基金卖出确认成功，充值恒宝宝确认失败后，资金2日内转入银行卡。<br>
              5. 如果您超过正常时间还未收到赎回款项，可拨打400-888-6661咨询。
            </p>
          </div>
        </section>
      </div>
    </div>
    <!-- 撤单 -->
    <el-dialog class="dialog-single-three" :visible.sync="dialogVisable" :close-on-click-modal="false" :before-close="cancelReturn">
      <div class="dialog-single-three-p">请输入支付密码</div>
      <el-form :model="cancelForm" ref="cancelFormRef" class="margin-t20" style="position: relative;">
        <el-form-item label="活动名称" prop="name" style="display:none;">
          <el-input v-model="cancelForm.name"></el-input>
        </el-form-item>
        <el-form-item prop="pass">
          <el-input ref="psdRef" v-model="cancelForm.pass" type="password" autocomplete="new-password" @blur="passBlur" @keyup.enter.native="canaleOrderClick" show-password></el-input>
          <span class="dialog-single-three-error" v-show="errorShow">{{errorMessage}}</span>
        </el-form-item>
      </el-form>
      <div class="margin-t35">
        <el-button type="normal1" @click="canaleOrderClick">确定</el-button>
        <el-button type="cancel" style="width:154px" @click="cancelReturn">返回</el-button>
      </div>
    </el-dialog>
  </div>

</template>

<script>
export default {
  data () {
    return {
      successMessage: '',
      stepDisplay: '',
      messageDetail: '',
      // 
      detailName: '申请已受理',
      detailStatus: '确认成功',
      detailProgress: '',

      confirmTime: '',
      // 撤单
      dialogVisable: false,
      errorShow: false,
      errorMessage: '',
      cancelForm: {
        name: '',
        pass: ''
      },
      payCard: '',
      // 时间
      acceptanceTime: '',
      iodate: '',
    }
  },
  created () {
    this.messageDetail = this.$route.params.message
    // console.log(this.messageDetail)
    // 时间
    this.messageDetail.applyTime = this.messageDetail.applyTime.replace('/', '年').replace('/', '月').replace(' ', '日')//申请时间
    this.acceptanceTime = this.$commonJs.getDateStrHz(this.messageDetail.transactiondate) + ' ' + this.messageDetail.transactiontime//受理时间
    this.iodate = this.messageDetail.iodate == "" ? this.$commonJs.getDateStrHz(this.messageDetail.transactiondate) : this.$commonJs.getDateStrHz(this.messageDetail.iodate)//成功时间

    if (this.messageDetail.businesscode == "22") { //充值
      if (this.messageDetail.transstatus == "01") {//充值成功
        this.detailStatus = "充值成功"
        this.detailProgress = "开始计算收益"
      } else if (this.messageDetail.transstatus == "02" || this.messageDetail.transstatus == "04" || this.messageDetail.transstatus == "06" || this.messageDetail.status == "03") {
        this.detailName = "充值失败"
      } else if (this.messageDetail.transstatus == "03") {
        this.detailStatus = '待确认'
        this.detailProgress = '开始计算收益'
      }
    } else if (this.messageDetail.businesscode == "39" || this.messageDetail.businesscode == "59" || this.messageDetail.businesscode == "60") { //定投
      this.detailStatus = "定投成功"
    } else if (this.messageDetail.businesscode == "24") { //普通提现
      if (this.messageDetail.transstatus == "03") {
        this.detailStatus = '待确认'
      }
    } else if (this.messageDetail.businesscode == "43") { //分红
      this.detailName = "分红确认"
    } else if (this.messageDetail.businesscode == "122") { //基金卖出
    } else if (this.messageDetail.businesscode == "124") { //基金买入
      if (this.messageDetail.transstatus == "00") {
        this.detailName = "交易失败退款"
      }
    }
  },
  mounted () {
    this.getTime()
  },
  methods: {
    returnClick () {
      this.$router.push({
        name: 'record'
      })
    },
    // 确认中时间
    getTime () {
      this.$http.post(this.$apiPath.hbbMessageInfo, {
        sessionId: this.$commonJs.getCookie('sessionid'),
        appsheetserialno: this.messageDetail.appsheetserialno
      }).then(res => {
        if (res.status !== 200 && res.data.code !== '200') return
        this.confirmTime = res.data.data.hbbTradeInfo[0]
        // console.log(this.confirmTime);
        this.payCard = this.$commonJs.getBankInfo(this.confirmTime.channelid) + '(*' + this.confirmTime.depositacct.substr(this.confirmTime.depositacct.length - 4) + ')'
      }).catch(err => { })
    },
    passBlur () {
      if (this.cancelForm.pass.trim() == "") {
        this.errorShow = true
        this.errorMessage = "请输入密码"
      } else {
        this.errorShow = false
        this.errorMessage = ""
      }
    },
    // 撤单确认
    cancelReturn () {
      this.dialogVisable = false
      this.errorShow = false
      this.$refs.cancelFormRef.resetFields()
    },
    canaleOrderClick () {
      if (this.cancelForm.pass.trim() == "") {
        this.errorShow = true
        this.errorMessage = "请输入密码"
      } else {
        this.errorShow = false
        this.errorMessage = ""
        var inputpwd = this.$des.enString(this.cancelForm.pass, this.$store.state.DESKEY.key1, this.$store.state.DESKEY.key2, this.$store.state.DESKEY.key3)
        var reallypass = this.$commonJs.getCookie('Password')
        if (inputpwd != reallypass) {
          this.errorShow = true
          this.errorMessage = "密码输入错误"
        } else {
          this.errorShow = false
          this.errorMessage = ""
          this.cancelOrder()
        }
      }
    },
    cancelOrder () {
      this.$http.post(this.$apiPath.deleteTradesnew, {
        sessionId: this.$commonJs.getCookie('sessionid'),
        originalappsheetno: this.messageDetail.appsheetserialno,
        appnew: '1'
      }).then(res => {
        // console.log(res);
        if (res.status !== 200) return
        if (res.data.code == "200" && res.data.success) {
          this.$message.success('撤销成功')
          this.$router.push({
            name: 'record'
          })
          //console.log(this.messageDetail.tradeType);
          if (this.messageDetail.tradeType == "充值" || this.messageDetail.tradeType == "汇款订单") {
            // 推送消息
            this.$store.dispatch({
              type: "pushNews",
              index: 15,
              fundname: "",
              money: this.messageDetail.transamount,
              dtDate: "",
              fundname2: ""
            })
          } else if (this.messageDetail.tradeType == "普通提现") {
            // 推送消息
            this.$store.dispatch({
              type: "pushNews",
              index: 17,
              fundname: "",
              money: this.messageDetail.transamount,
              dtDate: "",
              fundname2: ""
            })
          }

        } else {
          this.$message.error(res.data.message)
          this.dialogVisable = false
          this.$refs.cancelFormRef.resetFields()
        }
      }).catch(err => { })
    },
  }
}
</script>
